module.exports = __webpack_public_path__ + "img/tips.68694bd9.png";